import React, { useLayoutEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { StackModal } from 'Components/StackModal';
import { ReactComponent as CloseIcon } from 'themes/disonaTheme/icons/common/white-close-icon.svg';
import { ArrowRight } from 'common/ui/themes/disona/icons';
import { stores } from 'stores';
import { SvgWrapper } from 'common/ui/themes/disona/atoms/SvgWrapper';
import { theme } from 'styled-tools';
import { S } from './style';

const { ModalStore } = stores;
const ModalContent = ({
  children,
  title,
  withBackNavigation,
  onCloseCallback,
}) => {
  useLayoutEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const close = useCallback(() => {
    ModalStore.clearStack();
    if (onCloseCallback) onCloseCallback();
  }, [onCloseCallback]);

  return (
    <>
      <S.Overlay onClick={close} />
      <S.Modal>
        <S.Title>{title}</S.Title>
        {withBackNavigation && (
          <S.Back onClick={close}>
            <SvgWrapper
              currentColor="white"
              hoverColor={theme('colors.background.primaryColor')}
              width="10px"
            >
              <ArrowRight />
            </SvgWrapper>
          </S.Back>
        )}
        <S.Close onClick={close}>
          <CloseIcon />
        </S.Close>
        {children}
      </S.Modal>
    </>
  );
};

const FormModalBody = ({ children }) => (
  <S.Body>
    {children}
    <S.Gradient />
  </S.Body>
);

const FormModalSubmitMenu = observer(
  ({ saveButtonCallback, saveButtonText, saveButtonDisabled }) => {
    const { t } = useTranslation();
    return (
      <S.SubmitContainer>
        <S.CancelButton onClick={() => ModalStore.pop()}>
          {t('common.cancel')}
        </S.CancelButton>
        <S.SaveButton
          disabled={saveButtonDisabled}
          onClick={saveButtonCallback}
        >
          {saveButtonText}
        </S.SaveButton>
      </S.SubmitContainer>
    );
  }
);

const FormModal = observer(
  ({ ModalId, children, title, withBackNavigation, onCloseCallback }) => {
    return (
      <StackModal modalID={ModalId}>
        <ModalContent
          title={title}
          ModalStore={stores.ModalStore}
          ModalId={ModalId}
          withBackNavigation={withBackNavigation}
          onCloseCallback={onCloseCallback}
        >
          {children}
        </ModalContent>
      </StackModal>
    );
  }
);

export { FormModal, FormModalBody, FormModalSubmitMenu };
